import React, {} from 'react';
import { FaSort, FaSortDown, FaSortUp } from "react-icons/fa6";
import PropTypes from 'prop-types';

const CustomSortIcon = ({field, column, type}) => {
  if (column === field) {
    if (type === 'asc') {
      return <FaSortUp color="grey" />;
    }
    return <FaSortDown color="grey" />;
  }
  return <FaSort color="grey" />;
};

CustomSortIcon.propTypes = {
  field: PropTypes.string.isRequired,
  column: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

export default CustomSortIcon;